import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { Title } from '../../utils/title';
import contentful from '../../utils/contentful';
import Layout from './Layout';
import styles from './EntryList.module.scss';

const EntryList = ({ title, query, image, link }) => {

  const [ loading, setLoading ] = useState(false);
  const [ items, setItems ] = useState([]);

  useEffect(() => {

    setLoading(true);

    contentful.client
      .getEntries(query)
      .then(res => {
        setLoading(false);
        setItems(res.items);
      })
      .catch(err => {
        setLoading(false);
        setItems([]);
      });

  }, [query]);

  return (
    <>
      <Title value={title} />
      <Layout>
        <div className={styles.root}>

          <h1>{title}</h1>

          {
            loading && (
              <div className={styles.loading}>
                Loading...
              </div>
            )
          }

          {
            items.length > 0 && (
              <div className={styles.content}>
                {
                  items.map(item => (
                    <Link
                      key={item.fields.slug}
                      className={styles.item}
                      aria-label={item.fields.title}
                      to={link(item)}>

                      <div className={`
                        ${styles.image}
                        ${{
                          'cover': styles.cover,
                          'contain': styles.contain,
                        }[image.mode]}
                      `}>

                        <LazyLoadImage
                          src={`https:${item.fields[image.field].fields.file.url}`}
                          alt={
                            item.fields[image.field].fields.description ||
                            item.fields[image.field].fields.title
                          }
                        />
                      </div>

                      <div className={styles.title}>
                        {item.fields.title}
                      </div>

                      <div className={styles.date}>
                        {new Date(item.fields.publishedDate).toLocaleDateString()}
                      </div>

                    </Link>
                  ))
                }
              </div>
            )
          }

        </div>
      </Layout>
    </>
  );
};

export default EntryList;